import { addToOverviewList } from './changesOverview'
import { getReadableValue } from './getset'
import { changes } from './requests'

const keyFromId = {
  distriktFilter: 'reinbeitebruker_id_before', kartlagFilter: 'layer_name'
};
const toLabel = { Punkt: 'Anlegg (punkt)', Linje: 'Anlegg (linje)' };

const adaptOtherFilter = s1 => {
  const id1 = s1.id;
  // console.log('changed', id1, s1.selectedIndex, s1.value);
  ksFilter.querySelectorAll(`select:not(#${id1}) > option`).forEach((o, i) => {
    // console.log(o.value);
    if (i > 0) {
      const id2 = o.parentNode.id;
      o.disabled = (s1.selectedIndex > 0) ? !changes.filter(
        c => c[keyFromId[id1]] === s1.value
      ).some(c => c[keyFromId[id2]] === o.value) : false;
    }
  });
};

const maxChanges = 120;
export const filterAndLimitChangesOverview = e => {
  adaptOtherFilter(e.target);
  const tot = changes.length;
  const d = distriktFilter.value;
  const k = kartlagFilter.value;
  let count = 0;
  overviewFoot.hidden = true;
  changes.filter(c => c).forEach((c, i) => {
    const f = ['alle', c.layer_name,  c.reinbeitebruker_id_before];
    const fulfils = f.includes(d) && f.includes(k);
    if (fulfils) {
      if (count < maxChanges) { // limit the number of displayed maps
        const tr = c.inTheList ?? addToOverviewList(c, i);
        tr.hidden = false; // !fulfils
      }
      count++;
    } else if (c.inTheList) c.inTheList.hidden = true;
  });
  if (count > maxChanges) {
    manglendeEndringer.innerHTML = count - maxChanges;
    overviewFoot.hidden = false;
  }
};

const createOption = (value, label) => {
  const o = document.createElement('option');
  o.value = value;
  o.innerHTML = label || value;
  return o;
};

export const updateDistriktFilter = set => {
  for (let i = distriktFilter.length - 1; i > 0 ; i--) distriktFilter.remove(i);
  set.forEach(d => distriktFilter.appendChild(
    createOption(d, `${d} (${getReadableValue(d, 'reinbeitebruker')})`)
  ));
};

export const updateKartlagFilter = set => {
  for (let i = kartlagFilter.length - 1; i > 0 ; i--) kartlagFilter.remove(i);
  set.forEach(k => kartlagFilter.appendChild(createOption(k, toLabel[k])));
};
